import {PlayHubApi} from "modules/utils";
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {HOCisTrue as Exists} from 'components/HOCisTrue';
import {HOCHelpCollapsableSection} from 'components/HOCHelpCollapsableSection';
import {TermsTabContent} from 'pages/rules/TermsTabContent';
import {TriviaGuidelines} from 'pages/rules/TriviaGuidelines';
import {TriviaTerms} from 'pages/rules/TriviaTerms';
import {TriviaFaqs} from 'pages/rules/TriviaFaq';

const Wrapper = styled.div`
	padding: 20px 20px 100px 20px;
`;

const Title = styled.h1`
	font-size: 16px;
	line-height: 16px;
	font-family: ${({theme}) => theme.fonts.bold};
	color: ${({theme}) => theme.baseTextColor};
	padding: 20px 0;
`;

export interface IPasSection {
	name: string;
	text: string;
	position: number;
}

export const RulesPage: React.FC = () => {
	const [pasItems, setPasItems] = useState<IPasSection[]>([]);

	const fetchItems = async () => {
		const response = await PlayHubApi.JSON.terms_pas();
		if (response.items) {
			setPasItems(response.items as IPasSection[]);
		}
	}

	useEffect(() => {
		void fetchItems();
	}, []);

	return (
		<Wrapper>
			<Title>Pick A Side</Title>

			<Exists when={true}>
				{/*<HOCHelpCollapsableSection*/}
				{/*	title={'Rules'}*/}
				{/*	key={'key'}>*/}
				{/*	<RulesTabContent/>*/}
				{/*</HOCHelpCollapsableSection>*/}
				{pasItems?.map((item) => (
					<HOCHelpCollapsableSection
						title={item.name}
						key={item.name}>
						<TermsTabContent item={item}/>
					</HOCHelpCollapsableSection>
				))}

			</Exists>

			<Title>Trivia</Title>

			<Exists when={true}>
				<HOCHelpCollapsableSection
					title={'Rules'}
					key={'rules'}>
					<TriviaGuidelines/>
				</HOCHelpCollapsableSection>
				<HOCHelpCollapsableSection
					title={'Frequently asked questions'}
					key={'questions'}>
					<TriviaFaqs/>
				</HOCHelpCollapsableSection>
				<HOCHelpCollapsableSection
					title={'Terms and Conditions'}
					key={'terms'}>
					<TriviaTerms/>
				</HOCHelpCollapsableSection>
			</Exists>
		</Wrapper>
	);
};
